import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ProjectActivitySchedulingView } from "src/components/views/erp/project/scheduling/ProjectActivitySchedulingView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/project/scheduling")({
	staticData: { title: i18n.t("scheduling"), legacyViewKey: "projectActivitySchedulingPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ProjectActivitySchedulingView />;
}
